<div class="tabheadingsoverflow">
  <div class="floatinghead width100">
    <div class="row width100">
      <div class="col-lg-4">
        <h3 class="bluelabel margin-bottom-0 margin-top-10">Files</h3>
      </div>

      <div class="col-lg-8">
        <div class="docuemnt-right d-flex align-items-center">
          <div class="ml-auto d-flex">
            <div class="d-flex search-right">
              <div class="search-sec" style="padding-right: 10px">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                <i aria-hidden="true" class="fa fa-search icon"></i>
              </div>
              <div class="select-dropdown multiselectdesign multi-check-dropdown margin-right-10">
                 <mat-form-field  >
                   <mat-select placeholder="Filter By Category" panelClass="dynamic-width" [(ngModel)]="categoryids" (ngModelChange)="redrawTable()" multiple>
                    @if (categoryids.length > 1) {
                    <mat-select-trigger>
                        <span>{{ categoryids?.length }} items selected</span>
                    </mat-select-trigger>
                    }
                    @for (category of categoryLst; track category) {
                      <mat-option [value]="category.id" class="multi-dropdown-item">{{category.name}}</mat-option>
                    }
                    @if (categoryLst.length === 0) {
                      <mat-option class="matoptionnodata" disabled>
                        Nothing found...
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="select-dropdown multiselectdesign multi-check-dropdown" *ngIf="source=='MyPortfolio'">
                 <mat-form-field  >
                   <mat-select placeholder="Filter By Property" panelClass="dynamic-width" [(ngModel)]="selectedpropertyIds" (ngModelChange)="redrawTable()" multiple>
                    @if (selectedpropertyIds.length > 1) {
                      <mat-select-trigger>
                        <span>{{ selectedpropertyIds?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                    @for (property of propertyLst; track property) {
                      <mat-option [value]="property.id" class="multi-dropdown-item">{{property.name}}</mat-option>
                    }
                    @if (propertyLst.length === 0) {
                      <mat-option class="matoptionnodata" disabled>
                        Nothing found...
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="padding-left: 5px">
                <button type="button" class="btn btn-lg btn-addgreen margin-bottom pull-right"
                        (click)="OpenAddUserSlider(UploadFile, 'portfolioUpload','')" tooltip="Upload Files"
                        placement="left"
                        triggers="mouseenter:mouseleave">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="table-responsive margin-bottom-20 margin-top-15">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
      <thead>
        <tr>
          <th style="width:50px">#</th>
          <th style="width: 150px">Action</th>
          <th *ngIf="source=='MyPortfolio'">Property/Portfolio</th>
          <th>Document Title</th>
          <th>Category</th>
          <th>Uploaded By</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let doc of propertyDocuments; let i = index">
          <tr [ngClass]="{'highlighted' : i == 0}">
            <td>
              <p>{{i+1}}</p>
            </td>
            <td>
              <a class="blueone" tooltip="Edit File" href="javascript:void(0);" (click)="openEditModal(EditFile,'',doc.Id,doc.CategoryId,doc.ObjectId,doc.ObjectTypeId,doc.Name)" style="font-size:15px">
                <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
              </a>
              <a *ngIf="doc.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', doc)" placement="top">
                <i aria-hidden="true" class="fa fa-eye"></i>
              </a>
              <a *ngIf="doc.FilePath != null && doc.FilePath.length > 0" class="view" href={{doc.FilePath}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                 ng-reflect-placement="top" triggers="hover">
                <i aria-hidden="true" class="icofont icofont-download-alt"></i>
              </a>
              <a href="javascript:void(0);" (click)="openDeleteModal(RemoveFile, '', doc.Id);" class="remove" tooltip="Remove" placement="top">
                <i class="icofont icofont-close" aria-hidden="true"></i>
              </a>
            </td>
            <td *ngIf="source=='MyPortfolio'">{{doc.ObjectTypeId==null?'':doc.ObjectTypeId==302?doc.PropertyName:doc.ObjectTypeId==305?doc.PropertyName:'Portfolio'}}</td>
            <td>
              <p>{{doc.Name}}</p>
            </td>
            <td>
              <p>{{doc.Category}}</p>
              <!--<label class="select">
                <select class="form-control " [(ngModel)]="doc.CategoryId" (ngModelChange)="UpdateDocCategory(doc)">
                  <option *ngFor="let cat of categoryLst" [ngValue]="cat.id">{{cat.name}}</option>
                </select>
                <i></i>
              </label>-->
            </td>
            <td>
              <p>{{doc.UploadedBy}}</p>
            </td>
            <td>
              <p>
                {{doc.UploadedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(doc.UploadedDate), 'MM/dd/yyyy')) : '-'}}
              </p>
            </td>

          </tr>
        </ng-container>
      </tbody>
      <tr *ngIf="propertyDocuments.length === 0&&noDataShow!=1">
        <td colspan="6" style="text-align: center; font-weight: normal; color: gray">
          <div class="nodata">
            <i class="icofont icofont-warning icon"></i>
            <p>No Documents Added</p>
          </div>
        </td>
      </tr>
    </table>
  </div>

</div>

<ng-template #RemoveFile>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Remove File</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefDelete.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to remove this file ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDelete.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onRemoveDocument();">Remove</button>
    </div>
  </div>

</ng-template>

<ng-template #EditFile>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit File</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefEdit.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <label class="form-label">File Name : <b>{{fileName}}</b></label>
    <div class="form-group">
      <label class="form-label">File Category</label>
      <label class="select">
        <select class="form-control" [(ngModel)]="categoryId">
          <option *ngFor="let cat of categoryLst" [ngValue]="cat.id">{{cat.name}}</option>
        </select>
        <i></i>
      </label>
    </div>
    <div class="form-group">
      <label class="form-label">Property/Portfolio</label>
      <label class="select">
        <select class="form-control " [(ngModel)]="editProperty">
          <option value="0">--Select--</option>
          <option value="-1">Portfolio</option>
          <option *ngFor="let prop of propertyLst" [ngValue]="prop.id">{{prop.name}}</option>
        </select>
        <i></i>
      </label>
    </div>

    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefEdit.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="UpdateDocCategory();">Save</button>
    </div>
  </div>

</ng-template>

<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.FilePath" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

</ng-template>
<ng-template #UploadFile>
  <div class="modal-body modal-scroll-body padding30">
    <app-PortfolioFiles-Upload [inputOfferGuid]="" [UserGuid]="UserGuid" [modalRefUpload]="modalRef" [BackgroundFileStoring]="BackgroundFileStoring" [propertyId]="propertyId" [source]="source" (fileUploaded)="refreshFiles($event)"></app-PortfolioFiles-Upload>
  </div>
</ng-template>

